import classNames from 'classnames';
import React from 'react';
import type { ExtendWithCommonProps } from '../../types';
import scss from './list.module.scss';

export type ListItemProps = ExtendWithCommonProps<{
  children: React.ReactNode;
}>;

export const ListItem = React.forwardRef<React.ElementRef<'li'>, ListItemProps>(
  ({ children, className }, ref) => {
    const classes = classNames(scss[`list-item`], className);
    return (
      <li ref={ref} className={classes}>
        {children}
      </li>
    );
  },
);

ListItem.displayName = 'List.Item';
